import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, Step } from 'semantic-ui-react';

const StickyColumn = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  padding-top: 15px;
  padding-bottom: 0;
  background-color: #fff;
  z-index: 5;
  width: 100%;
`;

const ImpresaStatesStep = ({ state }) => {
  const stateSteps = () => [
    { key: 'state-0', title: 'Aperta', active: state === 'aperta' },
    { key: 'state-1', title: 'Conclusa', active: state === 'chiusa' },
  ];

  return (
    <StickyColumn>
      <Grid.Column>
        <Step.Group fluid ordered items={stateSteps()} style={{ height: '70px' }} />
      </Grid.Column>
    </StickyColumn>
  );
};

ImpresaStatesStep.propTypes = {
  /** string that can be 'aperta' or 'chiusa' */
  state: PropTypes.string.isRequired,
};

export default ImpresaStatesStep;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ImpresaStateStep/index.js